module.exports = __webpack_public_path__ + "static/software-30b0f7dc028f3f942e7bf106ddcfa69c.png";